export default "__VITE_PUBLIC_ASSET__347ac580__"